import { CSSProperties } from 'react';
import { COLORS, FONTS, META, GLASS } from '../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  card: {
    ...GLASS,
    padding: '2rem 1.75rem 2.25rem',
    transition: 'background 0.2s',
  },
  top: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '1.5rem',
  },
  icon: {
    width: '38px',
    height: '38px',
    background: COLORS.accentGlow,
    border: `1px solid ${COLORS.borderAccent}`,
    borderRadius: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  index: {
    ...META,
    fontSize: '0.7rem',
    color: COLORS.faint,
  },
  title: {
    fontFamily: FONTS.body,
    fontSize: '1.05rem',
    fontWeight: 600,
    color: COLORS.text,
    marginBottom: '0.6rem',
  },
  description: {
    fontSize: '0.875rem',
    color: COLORS.muted,
    lineHeight: 1.65,
  },
};
